import z from 'zod'

/** Single optimized G1 story layout (see docs/widgets/examples/g1-rss-vue). */
export const rssLayoutIdSchema = z.literal('story-full')

export type TRssLayoutId = z.infer<typeof rssLayoutIdSchema>

/** Layout appearance is fixed in player CSS; no per-feed options in v1. */
export const rssLayoutOptionsSchema = z.object({}).default({})

export type TRssLayoutOptions = z.infer<typeof rssLayoutOptionsSchema>

export const rssDirectoryRefOverridesSchema = z.object({
  durationSec: z.number().positive().optional(),
  slideCount: z.number().int().min(1).max(20).optional(),
  slideDurationSec: z.number().int().min(3).max(120).optional(),
  maxAgeSec: z.number().int().min(0).optional()
})

export type TRssDirectoryRefOverrides = z.infer<typeof rssDirectoryRefOverridesSchema>

/** Snapshot stored on playlist frames; layout fields copied from catalog at assignment time. */
export const rssDirectoryRefSchema = z.object({
  entryId: z.string().min(1),
  layoutId: rssLayoutIdSchema.default('story-full'),
  layoutOptions: rssLayoutOptionsSchema,
  overrides: rssDirectoryRefOverridesSchema.optional()
})

export type TRssDirectoryRef = z.infer<typeof rssDirectoryRefSchema>
